import {UmpireSeason} from '../umpire-season';
import {UmpireCompetition} from '../umpire-competition';
import {UmpireImage} from '../umpire-image';

export interface UmpireCompetitionSeason {
  type: string;

  id: string;

  name: string;

  season: UmpireSeason;

  image: UmpireImage | null;

  competition: UmpireCompetition;

  relationshipNames: string[];
}
